import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Login',
            component: () => import('../components/login/Index.vue')
        },
        {
            path: '/invalidSession',
            name: 'InvalidSession',
            component: () => import('../components/login/InvalidSession.vue')
        },
        {
            path: '/dashboard',
            component: () => import(/* webpackChunkName: "about" */ '../components/dashboard/Index'),
            children: [
                {
                    name: 'Dashboard',
                    path: '',
                    component: () => import(/* webpackChunkName: "about" */ '../components/Dashboard'),
                    props: { userType: '' }
                },
                {
                    name: 'MIKRO',
                    path: '/mikro',
                    component: () => import(/* webpackChunkName: "about" */ '../components/dashboard/UserList'),
                    props: { userType: 'MIKRO' }

                },
                {
                    name: 'SME',
                    path: '/sme',
                    component: () => import(/* webpackChunkName: "about" */ '../components/dashboard/UserList'),
                    props: { userType: 'SME' }
                },
                {
                    name: 'Learning Resources',
                    path: '/learningResources',
                    component: () => import(/* webpackChunkName: "about" */ '../components/LearningResources')
                }
            ]

        }
    ]
})
